import { ReloadOutlined } from '@ant-design/icons'
import { Col, Row } from 'antd'
import { Link } from 'gatsby'

export const FooterMenu: React.FC = () => {
  const handleRefresh = () => {
    // キャッシュをクリア
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach((name) => {
          caches.delete(name)
        })
      })
    }
    // ページリロード実行
    window.location.reload()
  }

  return (
    <div className="footer">
      <Row justify="center">
        <Col span={4} />
        <Col span={16}>
          <Link to="/privacy" className="mr-2 text-white hover:text-white">
            プライバシーポリシー
          </Link>
          {'|'}
          <Link to="/term-of-service" className="ml-2 mr-2 text-white hover:text-white">
            利用規約
          </Link>
        </Col>
        <Col span={4}>
          <span
            onClick={handleRefresh}
            className="ml-2 mr-0.5 text-white hover:text-white cursor-pointer"
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') handleRefresh()
            }}
          >
            リフレッシュ
          </span>
          <ReloadOutlined />
        </Col>
      </Row>
      <Row className="mt-2">
        <Col span={24} style={{ textAlign: 'center' }}>
          © 2022, SAGAサンライズパーク. Powered by 見積システム
        </Col>
      </Row>
    </div>
  )
}

export default FooterMenu
